/**
 * Arena (formerly LMArena) Direct-chat model allowlist (scraped 2026-07-09).
 * - Text + Search → chat registry (providers/registry/lmarena, wire id unchanged)
 * - Image → IMAGE_PROVIDERS in imageRegistry.ts (not chat catalog)
 * Live HTML discovery is disabled. Scrape JSON stays local/desktop only — not shipped.
 */
import type { RegistryModel } from "../../shared.ts";

export interface LmarenaDirectModelEntry {
  catalogId: string;
  arenaId: string;
  publicName: string;
  displayName: string;
  organization: string;
  vision: boolean;
  category: string;
}

export const LMARENA_DIRECT_MODEL_ENTRIES: readonly LmarenaDirectModelEntry[] = Object.freeze([
  {
    catalogId: "amazon.nova-pro-v1:0",
    arenaId: "a14546b5-d78d-4cf6-bb61-ab5b8510a9d6",
    publicName: "amazon.nova-pro-v1:0",
    displayName: "amazon.nova-pro-v1:0",
    organization: "amazon",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "claude-haiku-4-5-20251001",
    arenaId: "0199e8e9-01ed-73e0-96ba-cf43b286bf10",
    publicName: "claude-haiku-4-5-20251001",
    displayName: "claude-haiku-4-5-20251001",
    organization: "anthropic",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "claude-sonnet-5",
    arenaId: "019f19f2-41f1-7c6d-9891-48d02fd9952c",
    publicName: "claude-sonnet-5",
    displayName: "claude-sonnet-5-high",
    organization: "anthropic",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "deepseek-v4-pro-thinking",
    arenaId: "019dc1c1-c62d-7b70-85a1-e0565e29fce1",
    publicName: "deepseek-v4-pro-thinking",
    displayName: "deepseek-v4-pro-thinking",
    organization: "deepseek",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "dola-seed-2.0-preview-vision",
    arenaId: "019c6453-641a-74f8-a689-a8a67175a359",
    publicName: "dola-seed-2.0-preview-vision",
    displayName: "dola-seed-2.0-preview-vision",
    organization: "bytedance",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "ernie-5.0-preview-1220",
    arenaId: "019d44f1-26da-729f-a4ea-ddddfe7b4eae",
    publicName: "ernie-5.0-preview-1220",
    displayName: "ernie-5.0-preview-1220",
    organization: "baidu",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gemini-3.1-flash-lite",
    arenaId: "019f408a-186c-7f3a-9595-4e079e42a613",
    publicName: "gemini-3.1-flash-lite",
    displayName: "gemini-3.1-flash-lite",
    organization: "google",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gemini-3.1-pro-preview",
    arenaId: "019c7820-5480-78b6-9fef-04c0d7004054",
    publicName: "gemini-3.1-pro-preview",
    displayName: "gemini-3.1-pro-preview",
    organization: "google",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gemini-3.5-flash-high",
    arenaId: "019f406f-fc33-7b9d-9571-7b8443bc7ca0",
    publicName: "gemini-3.5-flash-high",
    displayName: "gemini-3.5-flash-high",
    organization: "google",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "significant-otter",
    arenaId: "019d2cd3-2641-7628-94bd-67ecb0a7134e",
    publicName: "significant-otter",
    displayName: "gemma-4-26b-a4b",
    organization: "google",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "pteronura",
    arenaId: "019d2cd2-dd83-75ab-a421-d0ba2e22b1e3",
    publicName: "pteronura",
    displayName: "gemma-4-31b",
    organization: "google",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "glm-5.1",
    arenaId: "019ebf6a-94d4-7649-b704-1dbbd5eb0942",
    publicName: "glm-5.1",
    displayName: "glm-5.2 (max)",
    organization: "zai",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "glm-5v-turbo",
    arenaId: "019d4a09-9651-78cb-86ea-bb0fa5ec77f4",
    publicName: "glm-5v-turbo",
    displayName: "glm-5v-turbo",
    organization: "zai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gpt-oss-120b",
    arenaId: "6ee9f901-17b5-4fbe-9cc2-13c16497c23b",
    publicName: "gpt-oss-120b",
    displayName: "gpt-oss-120b",
    organization: "openai",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "gpt-5.2-high",
    arenaId: "019b1449-0313-7911-b836-419e2ed79b2e",
    publicName: "gpt-5.2-high",
    displayName: "gpt-5.2-high",
    organization: "openai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gpt-5.4-mini-high",
    arenaId: "019cfcdd-5426-777e-8314-04619cb92cc4",
    publicName: "gpt-5.4-mini-high",
    displayName: "gpt-5.4-mini-high",
    organization: "openai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gpt-5.4-nano-high",
    arenaId: "019cfcdd-0bca-706f-92b5-a4c4cbd022d8",
    publicName: "gpt-5.4-nano-high",
    displayName: "gpt-5.4-nano-high",
    organization: "openai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "gpt-5.5-instant",
    arenaId: "019e71ea-1e1d-740f-9c2d-dab5869ff108",
    publicName: "gpt-5.5-instant",
    displayName: "gpt-5.5-instant",
    organization: "openai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "grok-4.3/text",
    arenaId: "019f42aa-9c3b-76d1-8bdf-2e883b1ca227",
    publicName: "grok-4.3",
    displayName: "grok-4.5",
    organization: "xai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "hunyuan-vision-1.5-thinking",
    arenaId: "6a3a1e04-050e-4cb4-9052-b9ac4bec0c38",
    publicName: "hunyuan-vision-1.5-thinking",
    displayName: "hunyuan-vision-1.5-thinking",
    organization: "tencent",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "hy3",
    arenaId: "019f3911-ba1c-7e36-b631-01893e557290",
    publicName: "hy3",
    displayName: "hy3",
    organization: "tencent",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "kimi-k2.6",
    arenaId: "019dac54-e8a4-7c54-904a-ff0ecd82af42",
    publicName: "kimi-k2.6",
    displayName: "kimi-k2.6",
    organization: "moonshot",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "ling-2.5-1t",
    arenaId: "019c6e76-fbbc-7e92-b0ba-784c7ef3ad8b",
    publicName: "ling-2.5-1t",
    displayName: "ling-2.5-1t",
    organization: "ant-group",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "longcat-2.0",
    arenaId: "019f3a0a-bd19-7b19-9eed-a98453759b48",
    publicName: "longcat-2.0",
    displayName: "longcat-2.0",
    organization: "meituan",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "mercury-2",
    arenaId: "019cc65f-c1e3-7574-b332-898ab71c8211",
    publicName: "mercury-2",
    displayName: "mercury-2",
    organization: "inception-ai",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "mimo-v2.5",
    arenaId: "019db651-bd2f-7d80-ab12-d69c6bb623df",
    publicName: "mimo-v2.5",
    displayName: "mimo-v2.5",
    organization: "xiaomi",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "mimo-v2.5-pro",
    arenaId: "019db650-909d-7dec-8711-1907d7233cd4",
    publicName: "mimo-v2.5-pro",
    displayName: "mimo-v2.5-pro",
    organization: "xiaomi",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "minimax-m3",
    arenaId: "019e809d-f62d-7192-bb7f-1657e066b5f2",
    publicName: "minimax-m3",
    displayName: "minimax-m3",
    organization: "minimax",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "mistral-large-3",
    arenaId: "019acbac-df7c-73dc-9716-ebe040daaa4e",
    publicName: "mistral-large-3",
    displayName: "mistral-large-3",
    organization: "mistral",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "mistral-medium-3.5",
    arenaId: "019f30a4-044d-7a14-9d3b-2e7299159e36",
    publicName: "mistral-medium-3.5",
    displayName: "mistral-medium-3.5",
    organization: "mistral",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "mistral-small-2603",
    arenaId: "019cf983-532b-73fa-a057-7658e1e1c5ee",
    publicName: "mistral-small-2603",
    displayName: "mistral-small-2603",
    organization: "mistral",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "nova-2-lite",
    arenaId: "019ae300-83b7-7717-a1e0-31accd1ff6fa",
    publicName: "nova-2-lite",
    displayName: "nova-2-lite",
    organization: "amazon",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "nvidia-nemotron-3-nano-30b-a3b-bf16",
    arenaId: "019b0aa7-334a-78e8-b2a8-885f31f4fc0c",
    publicName: "nvidia-nemotron-3-nano-30b-a3b-bf16",
    displayName: "nvidia-nemotron-3-nano-30b-a3b-bf16",
    organization: "nvidia",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "march26-chatbot1-public",
    arenaId: "019cd9e3-c3ff-7225-92f2-c392259b1fbe",
    publicName: "march26-chatbot1-public",
    displayName: "nvidia-nemotron-3-super-120b-a12b",
    organization: "nvidia",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "may26-chatbot4-public",
    arenaId: "019e8ea8-2052-7f2e-b1b6-59bd94be5203",
    publicName: "may26-chatbot4-public",
    displayName: "nvidia-nemotron-3-ultra-550b-a55b-nvfp4",
    organization: "nvidia",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "o3-2025-04-16",
    arenaId: "cb0f1e24-e8e9-4745-aabc-b926ffde7475",
    publicName: "o3-2025-04-16",
    displayName: "o3-2025-04-16",
    organization: "openai",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "qwen3.5-397b-a17b",
    arenaId: "019c6918-1d2a-7e3f-88ec-ada000b6ab16",
    publicName: "qwen3.5-397b-a17b",
    displayName: "qwen3.5-397b-a17b",
    organization: "alibaba",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "qwen3.7-max",
    arenaId: "019e6530-f140-77b1-b6b8-5c859829d992",
    publicName: "qwen3.7-max",
    displayName: "qwen3.7-max",
    organization: "alibaba",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "qwen3.7-plus",
    arenaId: "019e86fe-167d-77bd-94a8-df7aee4f4551",
    publicName: "qwen3.7-plus",
    displayName: "qwen3.7-plus",
    organization: "alibaba",
    vision: true,
    category: "Text",
  },
  {
    catalogId: "ring-2.5-1t",
    arenaId: "019c6e77-1b9f-7649-9136-43d07566c6c5",
    publicName: "ring-2.5-1t",
    displayName: "ring-2.5-1t",
    organization: "ant-group",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "step-3.5-flash",
    arenaId: "019d22bb-fcf5-7866-9c07-de74fe05c9cc",
    publicName: "step-3.5-flash",
    displayName: "step-3.5-flash",
    organization: "stepfun",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "trinity-large-thinking",
    arenaId: "019d50aa-447d-74d6-8661-405b4b6de5de",
    publicName: "trinity-large-thinking",
    displayName: "trinity-large-thinking",
    organization: "arcee-ai",
    vision: false,
    category: "Text",
  },
  {
    catalogId: "cosmos3-super",
    arenaId: "019f4270-5d10-723c-8a7e-dfd5dd2214e5",
    publicName: "cosmos3-super",
    displayName: "cosmos3-super",
    organization: "nvidia",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "cosmos3-super-agentic",
    arenaId: "019f4270-9eea-79c3-b18f-71303ee41ff8",
    publicName: "cosmos3-super-agentic",
    displayName: "cosmos3-super-agentic",
    organization: "nvidia",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "flux-2-dev",
    arenaId: "019b478d-74ae-7d19-9a8f-6cfde89ab4ca",
    publicName: "flux-2-dev",
    displayName: "flux-2-dev",
    organization: "bfl",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "flux-2-pro",
    arenaId: "019b7541-5e4b-7ff7-a34b-b0255b6ca9aa",
    publicName: "flux-2-pro",
    displayName: "flux-2-pro",
    organization: "bfl",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "gemini-2.5-flash-image-preview (nano-banana)",
    arenaId: "0199ef2a-583f-7088-b704-b75fd169401d",
    publicName: "gemini-2.5-flash-image-preview (nano-banana)",
    displayName: "gemini-2.5-flash-image-preview (nano-banana)",
    organization: "google",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "instant-ramen",
    arenaId: "019ed3b3-c4f8-7e67-b72d-385d740096d0",
    publicName: "instant-ramen",
    displayName: "gemini-3.1-flash-lite-image (nano-banana-2-lite)",
    organization: "google",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "gpt-image-1",
    arenaId: "6e855f13-55d7-4127-8656-9168a9f4dcc0",
    publicName: "gpt-image-1",
    displayName: "gpt-image-1",
    organization: "openai",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "blue-crab",
    arenaId: "019e4271-4717-7dd9-a0e2-90783fbabd25",
    publicName: "blue-crab",
    displayName: "grok-imagine-image-quality (20260519)",
    organization: "xai",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "hidream-o1-image",
    arenaId: "019e1cd7-5cc5-75d2-8b3e-275616dec624",
    publicName: "hidream-o1-image",
    displayName: "hidream-o1-image",
    organization: "hidream",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "sungod",
    arenaId: "019bec2d-e92c-745d-ae46-c7166590237a",
    publicName: "sungod",
    displayName: "hunyuan-image-3.0-instruct",
    organization: "tencent",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "ideogram-v3-quality",
    arenaId: "73378be5-cdba-49e7-b3d0-027949871aa6",
    publicName: "ideogram-v3-quality",
    displayName: "ideogram-v3-quality",
    organization: "Ideogram",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "krea-2-large",
    arenaId: "019e8ebd-6cfb-7492-949c-a2c4a00301aa",
    publicName: "krea-2-large",
    displayName: "krea-2-large",
    organization: "krea",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "krea-2-turbo",
    arenaId: "019f049d-7de4-7fae-8237-1c2103b9e730",
    publicName: "krea-2-turbo",
    displayName: "krea-2-turbo",
    organization: "krea",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "lucid-origin",
    arenaId: "5a3b3520-c87d-481f-953c-1364687b6e8f",
    publicName: "lucid-origin",
    displayName: "lucid-origin",
    organization: "leonardo-ai",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "kakarot-v2",
    arenaId: "019e80aa-37bf-7e89-8a28-41e4ab72ed9f",
    publicName: "kakarot-v2",
    displayName: "mai-image-2.5 (image-edit)",
    organization: "microsoft-ai",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "baryonyx",
    arenaId: "019e530d-2a50-75e3-95d1-a5ef41d4c24c",
    publicName: "baryonyx",
    displayName: "mai-image-2.5 (text-to-image)",
    organization: "microsoft-ai",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "iron-bloom",
    arenaId: "019ef780-25ef-7878-8b91-307f8f879d42",
    publicName: "iron-bloom",
    displayName: "muse-image",
    organization: "meta",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "photon",
    arenaId: "e7c9fa2d-6f5d-40eb-8305-0980b11c7cab",
    publicName: "photon",
    displayName: "photon",
    organization: "luma-ai",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "qwen-image-2.0",
    arenaId: "019d287c-4906-7f9c-8b78-8a2a86cf00a5",
    publicName: "qwen-image-2.0",
    displayName: "qwen-image-2.0",
    organization: "alibaba",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "qwen-image-2.0-pro",
    arenaId: "019d287b-b718-7daa-ad65-502596d0813d",
    publicName: "qwen-image-2.0-pro",
    displayName: "qwen-image-2.0-pro",
    organization: "alibaba",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "recraft-v4",
    arenaId: "019c6e76-a7c0-7b05-8dce-bbe3d52c8f4e",
    publicName: "recraft-v4",
    displayName: "recraft-v4",
    organization: "Recraft",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "avalon",
    arenaId: "019e7091-f73f-7338-b5e2-4ab5fba37dc2",
    publicName: "avalon",
    displayName: "reve-2.0 (image-edit)",
    organization: "reve",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "babylon",
    arenaId: "019e86c6-a3dc-73ac-9adc-8c5f304dc2fb",
    publicName: "babylon",
    displayName: "reve-2.0 (text-to-image)",
    organization: "reve",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "seedream-5.0-pro",
    arenaId: "019f42b5-8c52-7793-9be8-de35eecf7ea9",
    publicName: "seedream-5.0-pro",
    displayName: "seedream-5.0-pro",
    organization: "bytedance",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "uni-1.1-max",
    arenaId: "019ed208-69ca-7f3f-85ee-182d5f0ea08b",
    publicName: "uni-1.1-max",
    displayName: "uni-1.1-max",
    organization: "luma-ai",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "wan2.7-image-pro",
    arenaId: "019db3f0-b024-7478-bd4d-55ea1ec1d421",
    publicName: "wan2.7-image-pro",
    displayName: "wan2.7-image-pro",
    organization: "wan",
    vision: true,
    category: "Image",
  },
  {
    catalogId: "zen-bear-v3",
    arenaId: "019f38c2-002d-7f0f-a391-db6df024b734",
    publicName: "zen-bear-v3",
    displayName: "zen-bear-v3",
    organization: "alibaba",
    vision: false,
    category: "Image",
  },
  {
    catalogId: "claude-sonnet-5-search",
    arenaId: "019f1a07-de72-7fbe-8d82-56dbd7348360",
    publicName: "claude-sonnet-5-search",
    displayName: "claude-sonnet-5-search",
    organization: "anthropic",
    vision: false,
    category: "Search",
  },
  {
    catalogId: "gemini-2.5-pro-grounding",
    arenaId: "b222be23-bd55-4b20-930b-a30cc84d3afd",
    publicName: "gemini-2.5-pro-grounding",
    displayName: "gemini-2.5-pro-grounding",
    organization: "google",
    vision: false,
    category: "Search",
  },
  {
    catalogId: "gemini-3-flash-grounding",
    arenaId: "019bda1f-3abc-783f-aac0-1ee102b247ba",
    publicName: "gemini-3-flash-grounding",
    displayName: "gemini-3-flash-grounding",
    organization: "google",
    vision: false,
    category: "Search",
  },
  {
    catalogId: "gpt-5.2-search",
    arenaId: "019b1448-f74a-72de-b25d-8666618f8c5a",
    publicName: "gpt-5.2-search",
    displayName: "gpt-5.2-search",
    organization: "openai",
    vision: false,
    category: "Search",
  },
  {
    catalogId: "grok-4.3/search",
    arenaId: "019de22d-1445-7296-9c88-a5877bc66ef8",
    publicName: "grok-4.3",
    displayName: "grok-4.3",
    organization: "xai",
    vision: false,
    category: "Search",
  },
  {
    catalogId: "o3-search",
    arenaId: "fbe08e9a-3805-4f9f-a085-7bc38e4b51d1",
    publicName: "o3-search",
    displayName: "o3-search",
    organization: "openai",
    vision: false,
    category: "Search",
  },
] as LmarenaDirectModelEntry[]);

/** Chat-completions catalog (Text + Search). Image rows are excluded. */
export const LMARENA_DIRECT_CHAT_ENTRIES: readonly LmarenaDirectModelEntry[] =
  LMARENA_DIRECT_MODEL_ENTRIES.filter((m) => m.category === "Text" || m.category === "Search");

/** Image-generation catalog rows (IMAGE_PROVIDERS). */
export const LMARENA_DIRECT_IMAGE_ENTRIES: readonly LmarenaDirectModelEntry[] =
  LMARENA_DIRECT_MODEL_ENTRIES.filter((m) => m.category === "Image");

export const LMARENA_DIRECT_MODELS: RegistryModel[] = LMARENA_DIRECT_CHAT_ENTRIES.map((m) => ({
  id: m.catalogId,
  name: m.displayName,
  ...(m.vision ? { supportsVision: true as const } : {}),
}));

export const LMARENA_DIRECT_IMAGE_MODELS: Array<{
  id: string;
  name: string;
  inputModalities?: string[];
}> = LMARENA_DIRECT_IMAGE_ENTRIES.map((m) => ({
  id: m.catalogId,
  name: m.displayName,
  inputModalities: m.vision ? ["text", "image"] : ["text"],
}));

export function resolveLmarenaArenaId(catalogOrArenaId: string): string | null {
  const raw = catalogOrArenaId.replace(/^(?:lmarena|lma|arena)\//i, "").trim();
  if (!raw) return null;
  const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (uuidRe.test(raw)) return raw;
  const lower = raw.toLowerCase();
  const hit = LMARENA_DIRECT_MODEL_ENTRIES.find(
    (m) =>
      m.catalogId === raw ||
      m.publicName === raw ||
      m.displayName === raw ||
      m.catalogId.toLowerCase() === lower ||
      m.publicName.toLowerCase() === lower ||
      m.displayName.toLowerCase() === lower
  );
  return hit?.arenaId ?? null;
}
